import ContractorCardGrid from '../../../Dashboard/Contractors/SubComponents/ContractorDetailsFlows/ContractorCardGrid';
import DivContainerBody from '../../../../components/DivContainerBody';
import HeadTittle from '../../../../components/HeadTittle';
import { CommonMainDetailsApp } from '../../../Dashboard/Contractors/Functionality/ContractorDetailsFlows/CommonMainDetailsApp';
import { EmployeeFlowSuppliersDetailsPageApp } from '../Funtionality/SupplierDetailsFlows/EmployeeFlowSuppliersDetailsPageApp';
import CustomExpandableTable from '../../../../components/table/CustomExpandableTable';
/**
 * @Author: Susana Garcia Rodriguez
 * @JobTitle: Frontend
 * @Email: sgarcia@ibl.mx
 */
const EmployeeSuppliersDetails = () => {
    const props = CommonMainDetailsApp();
    const {
        t,
        dispatch,
        params,
        elementDetails,
        setElementDetails,
    } = props;

    const {
        handleRowExpand,
        columns,
        sections,
        handleOnBack
    } = EmployeeFlowSuppliersDetailsPageApp({
        dispatch,
        params,
        setElementDetails
    });

    return (
        <>
            <HeadTittle name={t('details')} onBack={handleOnBack} />

            <DivContainerBody>
                <div className='row px-0 pb-5'>
                    <div className='col-sm-12 col-md-4 col-lg-3 px-0 mb-sm-3'>
                        <ContractorCardGrid elementDetails={elementDetails} />
                    </div>
                    <div className='col-sm-12 col-md-8 col-lg-9 px-0'>
                        {/**Done*/}
                        <CustomExpandableTable
                            columns={columns}
                            rows={sections}
                            checkbox={false}
                            rowsPerPage={sections.length}
                            selectedList={[]}
                            handleCheckboxChange={() => {}}
                            handleDeleteAll={() => {}}
                            renderExpandedRow={({ row }) => row.content()}
                            renderOptionsMenu={null}
                            onRowExpand={handleRowExpand}
                            tooltip={false}
                            showHeader={false}
                            withoutHeight={true}
                        />
                    </div>
                </div>
            </DivContainerBody>
        </>
    );
};

export default EmployeeSuppliersDetails;
